import { useEffect, useState } from 'react';

export default function useWindowDimensions() {
    const [windowDimensions, setWindowDimensions] = useState(
        getWindowDimensions()
    );
    const delay = 250; // delay between calls

    useEffect(() => {
        function handleResize() {
            setTimeout(function () {
                setWindowDimensions(getWindowDimensions());
            }, delay);
        }

        window.addEventListener('resize', function () {
            handleResize();
        });
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return windowDimensions;
}

const getWindowDimensions = () => {
    const { innerWidth: windowWidth, innerHeight: windowHeight } = window;
    return {
        windowWidth,
        windowHeight,
    };
};

export enum BootstrapBreakpoints {
    sm = 576,
    md = 768,
    lg = 992,
    xl = 1200,
    xxl = 1400,
}
